import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAxios } from "hooks/useAxios";
import { catalogKeys } from "queries/profile.keys";
import type { AppState } from "store/reducers/Reducer";
import type { UserCatalog } from "types/user-catalog";
import { fetchUserCatalog } from "./fetchUserCatalog";
import { sessionQueryRetry } from "./sessionQueryRetry";

export const useUserCatalog = () => {
  const axios = useAxios({ allResponse: true });
  const queryClient = useQueryClient();
  const token = useSelector((state: AppState) => state.auth.token);
  const cachedCatalog = queryClient.getQueryData<UserCatalog>(catalogKeys.me());

  return useQuery<UserCatalog>({
    queryKey: catalogKeys.me(),
    queryFn: () => fetchUserCatalog(axios),
    enabled: Boolean(cachedCatalog) || Boolean(token),
    staleTime: 5 * 60 * 1000,
    retry: sessionQueryRetry,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};
